<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-users mr-2" />Customer</h5>
            <hr />
            <b-row class="align-items-end">
                <b-col md="8">
                    <div class="d-flex">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button variant="dark" @click="showModalFilter">
                                    <i class="fa fa-search mr-2" />Filter...
                                </b-button>
                            </b-input-group-prepend>
                            <b-form-input v-model="filter.name" placeholder="Cari Nama..."
                                @keydown.enter="getItems" />

                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-form-input v-model="filter.phone" placeholder="Cari No. Handphone..."
                                @keydown.enter="getItems" />
                            <b-input-group-append>
                                <b-button variant="primary" @click="getItems">Cari</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-button class="ml-2" variant="danger" @click="clearFilter">
                            Reset
                        </b-button>
                    </div>
                </b-col>
                <b-col md="4" class="text-right">
                    <b-form-group v-if="isCustomerCreate" label="Tambah" class="mb-0">
                        <b-button id="btn-create-customer" variant="success" @click="handleModalCreateCustomer">
                            <i class="fa fa-plus mr-2" />Customer Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="justify-content-end mt-3">
                <b-col md="3" class="text-right">
                    <b-form-group label="Aksi">
                        <b-button id="btn-search" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button id="btn-download" class="ml-2 btn-dark" @click="downloadMasterCustomer()">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table id="customer-table" v-if="isCustomerView" bordered hover show-empty no-local-sorting :busy="isBusy" :items="items"
                :fields="fields" @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data customer.
                </template>

                <template v-slot:cell(name)="row">
                    {{ row.item.name || "-" }}
                    <div class="small text-muted">
                        {{ row.item.name_city || "-" }}
                    </div>
                    <div class="small text-muted">
                        {{ row.item.phone || "-" }}
                    </div>
                </template>

                <template v-slot:cell(credit)="row">
                    Rp. {{ $helper.formatThousand(row.item.credit) }}
                </template>

                <template v-slot:cell(debt)="row">
                    Rp. {{ $helper.formatThousand(row.item.debt) }}
                </template>

                <template v-slot:cell(limit_credit)="row">
                    {{ limitCreditCheck(row.item) }}
                    <div>
                        <b-badge v-if="row.item.is_overlimit" variant="primary">
                            Overlimit ON
                        </b-badge>
                    </div>
                </template>

                <template v-slot:cell(last_payment)="row">
                    <div v-if="row.item.last_payment == null">-</div>
                    <div v-else>{{ $helper.parseDate(row.item.last_payment) }}</div>
                </template>

                <template v-slot:cell(status)="row">
                    <b-badge :variant="row.item.is_blacklisted == 0 ? 'success' : 'secondary'" class="mb-0">
                        {{ row.item.is_blacklisted == 0 ? 'Aktif' : 'Blacklist' }}
                    </b-badge>
                    <br />
                    <b-badge :variant="row.item.allow_manual_payment == 1 ? 'success' : 'secondary'" class="mb-0">
                        {{ row.item.allow_manual_payment ? "Manual Payment Aktif" : "Manual Payment Off" }}
                    </b-badge>
                </template>

                <template v-slot:cell(action)="row">
                    <b-button id="btn-edit-customer" v-if="isCustomerEdit" size="sm" variant="warning" class="mr-2" v-b-tooltip.hover.top
                        title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button id="btn-edit-piutang" v-if="isCustomerEditPiutang" size="sm" variant="primary" class="mr-2"
                        v-b-tooltip.hover.top title="Edit Piutang" @click="preparePiutang(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button id="btn-generate-token" size="sm" variant="secondary" class="mr-2"
                        v-b-tooltip.hover.top title="Copy Self Payment Url" @click="copyPaymentUrl(row.item)">
                        <i class="fa fa-fw fa-link" />
                    </b-button>
                    <b-button id="btn-customer-blacklist"
                    v-if="isCustomerBlacklist && !row.item.is_blacklisted"
                    size="sm" variant="danger" class="mr-2"
                    v-b-tooltip.hover.top title="Blacklist" 
                    @click="openConfirmBlacklist(row.item, true)"
                    >
                        <i class="fa fa-fw fa-ban" />
                    </b-button>
                    <b-button id="btn-customer-unblacklist"
                    v-if="isCustomerBlacklist && row.item.is_blacklisted"
                    size="sm" variant="success" class="mr-2"
                    v-b-tooltip.hover.top title="Lepas Blacklist" 
                    @click="openConfirmBlacklist(row.item, false)"
                    >
                        <i class="fa fa-fw fa-unlock" />
                    </b-button>
                    <b-button id="btn-customer-allow-manual-payment" 
                    v-if="isCustomerAllowManualPayment" 
                    size="sm" class="mr-2"
                    :variant="row.item.allow_manual_payment ? 'success' : 'secondary'"
                    v-b-tooltip.hover.top :title="row.item.allow_manual_payment == 0 ? 'Ijinkan Pembayaran Manual' : 'Blokir Pembayaran Manual'" 
                    @click="openConfirmAllowManualPayment(row.item, row.item.allow_manual_payment == 1 ? false : true)"
                    >
                        <i class="fa fa-fw fa-credit-card" />
                    </b-button>
                    <b-button id="btn-reset-pin"
                    v-if="isCustomerResetPin"
                    size="sm" variant="info" class="mr-2"
                    v-b-tooltip.hover.top title="Reset PIN"
                    @click="openConfirmResetPin(row.item)"
                    >
                        <i class="fa fa-fw fa-key" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer id="page-sizer" :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" size="xl" title="Tambah Customer Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>

                <b-col md="12">
                    <h5 class="mb-0">Data Pribadi</h5>
                    <hr />
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="storeName">Nama Toko<span style="color:red;">*</span></label>
                        <b-input id="input-storeName" v-model="input.storeName" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="name">Nama Customer<span style="color:red;">*</span></label>
                        <b-input id="input-name" v-model="input.name" maxlength="100" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group>
                        <label for="input-phone">No. Handphone<span style="color:red;">*</span></label>
                        <b-input id="input-phone" type="number" v-model="input.phone" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-birthday">Tanggal Lahir<span style="color:red;">*</span></label>
                        <b-input id="input-birthday" type="date" v-model="input.birthday" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-whatsapp">No. WA<span style="color:red;">*</span></label>
                        <b-input id="input-whatsapp" type="number" v-model="input.whatsapp" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-email">Email<span style="color:red;">*</span></label>
                        <b-input id="input-email" v-model="input.email" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-nik">NIK / No. KTP<span style="color:red;">*</span></label>
                        <b-input id="input-nik" type="number" v-model="input.nik" maxlength="100" />
                    </b-form-group>
                </b-col>

               <b-col md="12">
                    <b-form-group label="Preview KTP / SIM">
                        <b-img id="input-ktp-preview" height="250" width="300" v-if="input.ktpPreview" :src="input.ktpPreview" fluid thumbnail
                            @click="showImagePreview(input.ktpPreview)" class="cursor-pointer" />
                        <b-img id="input-ktp-preview-placeholder" height="250" width="300" v-else src="/img/img-preview.png" fluid thumbnail />
                    </b-form-group>
                    <b-form-group>
                        <label for="input-ktp">File KTP / SIM<span style="color:red;">*</span></label>
                        <b-form-file id="input-ktp" v-model="input.ktp" accept="image/*" @change="(e) => onFileChangeInput(e, 'ktpPreview')" />
                    </b-form-group>
                </b-col>


                <b-col md="12">
                    <b-form-group label="Preview Surat Pernyataan">
                        <b-img id="input-statement-letter-preview" height="250" width="300" v-if="input.statementLetterPreview" :src="input.statementLetterPreview" fluid thumbnail
                            @click="showImagePreview(input.statementLetterPreview)" class="cursor-pointer" />
                        <b-img id="input-statement-letter-preview-placeholder" height="250" width="300" v-else src="/img/img-preview.png" fluid thumbnail />
                    </b-form-group>
                    <b-form-group>
                        <label for="input-statement-letter">File Surat Pernyataan<span style="color:red;">*</span></label>
                        <b-form-file id="input-statement-letter" v-model="input.statementLetter" accept="image/*" @change="(e) => onFileChangeInput(e, 'statementLetterPreview')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <h5 class="mb-0">Alamat Rumah</h5>
                    <hr />
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-house-province">
                        <label for="input-houseProvince">Provinsi<span style="color:red;">*</span></label>
                            <multiselect id="input-houseProvince" :internal-search="true" label="name" track-by="id" v-model="input.houseProvince"
                                :options="optProvince" :disabled="optProvince.length == 0"
                                @input="getCity(input.houseProvince.id)" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-house-city">
                        <label for="input-houseCity">Kabupaten / Kota<span style="color:red;">*</span></label>
                            <multiselect id="input-houseCity" :internal-search="true" label="name" track-by="id" :disabled="optCity.length == 0"
                                text-field="name" value-field="id" v-model="input.houseCity" :options="optCity"
                                @input="getDistrict(input.houseCity.id)" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-house-district">
                        <label for="input-houseDistrict">Kecamatan<span style="color:red;">*</span></label>
                            <multiselect id="input-houseDistrict" :internal-search="true" label="name" track-by="id"
                                :disabled="optDistrict.length == 0" text-field="name" value-field="id"
                                v-model="input.houseDistrict" :options="optDistrict" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-house-postal-code">Kode Pos<span style="color:red;">*</span></label>
                        <b-input id="input-house-postal-code" v-model="input.housePostalCode" maxlength="5" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="input-house-address">Alamat<span style="color:red;">*</span></label>
                        <b-form-textarea id="input-house-address" v-model="input.houseAddress" rows="3" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <div class="d-flex align-middle">
                        <h5 class="mb-0 mr-3 my-auto">Alamat Domisili</h5>
                        <b-button id="btn-copy-address-home-domicile" variant="primary" @click="copyAddressHomeDomicile">Salin dari Alamat Rumah</b-button>
                    </div>
                    <hr />
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-domicile-province">Provinsi<span style="color:red;">*</span></label>
                        <div id="input-domicile-province">
                            <multiselect id="input-domicileProvince" :internal-search="true" label="name" track-by="id" v-model="input.domicileProvince"
                                :options="optProvince" :disabled="optProvince.length == 0"
                                @input="getDomicileCity(input.domicileProvince.id)" />
                        </div>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-domicile-city">
                        <label for="domicile-city">Kabupaten / Kota<span style="color:red;">*</span></label>
                            <multiselect id="domicile-city" :internal-search="true" label="name" track-by="id" v-model="input.domicileCity"
                                :options="domicileOptCity" :disabled="domicileOptCity.length == 0"
                                @input="getDomicileDistrict(input.domicileCity.id)" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-domicile-district">
                        <label for="domicile-district">Kecamatan<span style="color:red;">*</span></label>
                            <multiselect id="domicile-district" :internal-search="true" label="name" track-by="id" v-model="input.domicileDistrict"
                                :options="domicileOptDistrict" :disabled="domicileOptDistrict.length == 0" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-domicile-postal-code">Kode Pos<span style="color:red;">*</span></label>
                        <b-input id="input-domicile-postal-code" v-model="input.domicilePostalCode" maxlength="5" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="input-domicile-address">Alamat<span style="color:red;">*</span></label>
                        <b-form-textarea id="input-domicile-address" v-model="input.domicileAddress" rows="3" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <div class="d-flex align-middle">
                        <h5 class="mb-0 mr-3 my-auto">Data Toko</h5>
                        <b-button id="btn-copy-address-home-store" variant="primary" @click="copyAddressHomeStore">Salin dari Alamat Rumah</b-button>
                    </div>
                    <hr />
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-store-province">
                        <label for="store-province">Provinsi<span style="color:red;">*</span></label>
                            <multiselect id="store-province" :internal-search="true" label="name" track-by="id" v-model="input.storeProvince"
                                :options="optProvince" :disabled="optProvince.length == 0"
                                @input="getStoreCity(input.storeProvince.id)" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-store-city">
                        <label for="store-city">Kabupaten / Kota<span style="color:red;">*</span></label>
                            <multiselect id="store-city" :internal-search="true" label="name" track-by="id" v-model="input.storeCity"
                                :options="storeOptCity" :disabled="storeOptCity.length == 0"
                                @input="getStoreDistrict(input.storeCity.id)" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group id="input-store-district">
                        <label for="store-district">Kecamatan<span style="color:red;">*</span></label>
                            <multiselect id="store-district" :internal-search="true" label="name" track-by="id" v-model="input.storeDistrict"
                                :options="storeOptDistrict" :disabled="storeOptDistrict.length == 0" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="input-store-postal-code">Kode Pos<span style="color:red;">*</span></label>
                        <b-input id="input-store-postal-code" v-model="input.storePostalCode" maxlength="5" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="input-store-address">Alamat<span style="color:red;">*</span></label>
                        <b-form-textarea id="input-store-address" v-model="input.storeAddress" rows="3" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <h5 class="mb-0">Akun Sosial Media</h5>
                    <hr />
                </b-col>

                <b-col md="6">
                    <b-form-group label="IG">
                        <b-input id="input-ig" v-model="input.ig" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="TikTok">
                        <b-input id="input-tiktok" v-model="input.tiktok" maxlength="100" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Facebook">
                        <b-input id="input-facebook" v-model="input.facebook" maxlength="100" />
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="mt-4 text-right">
                <b-button id="btn-confirm-create" variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" size="xl" title="Edit Customer" no-close-on-backdrop no-close-on-esc hide-footer>
            <template v-if="!isLoading">

                Mengubah customer <strong>{{ activeItem.name }}</strong>
                <b-row>

                    <b-col md="12">
                        <h5 class="mb-0">Data Pribadi</h5>
                        <hr />
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-storeName">Nama Toko<span style="color:red;">*</span></label>
                            <b-input id="edit-storeName" v-model="edit.storeName" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-name">Nama Customer<span style="color:red;">*</span></label>
                            <b-input id="edit-name" v-model="edit.name" maxlength="100" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-phone">No. Handphone<span style="color:red;">*</span></label>
                            <b-input id="edit-phone" type="number" v-model="edit.phone" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-birthday">Tanggal Lahir<span style="color:red;">*</span></label>
                            <b-input id="edit-birthday" type="date" v-model="edit.birthday" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-whatsapp">No. WA<span style="color:red;">*</span></label>
                            <b-input id="edit-whatsapp" type="number" v-model="edit.whatsapp" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-email">Email<span style="color:red;">*</span></label>
                            <b-input id="edit-email" v-model="edit.email" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-nik">NIK / No. KTP<span style="color:red;">*</span></label>
                            <b-input id="edit-nik" type="number" v-model="edit.nik" maxlength="100" />
                        </b-form-group>
                    </b-col>

                   <b-col md="12">
                        <b-form-group label="Preview KTP / SIM">
                            <b-img id="edit-ktp-preview" height="250" width="300" v-if="edit.ktpPreview" :src="edit.ktpPreview" fluid thumbnail
                                @click="showImagePreview(edit.ktpPreview)" class="cursor-pointer" />
                            <b-img id="edit-ktp-preview-placeholder" height="250" width="300" v-else-if="activeItem.customer_details" :src="$BASE_FILE_PATH + activeItem.customer_details.photo_ktp" fluid thumbnail
                                @click="showImagePreview($BASE_FILE_PATH + activeItem.customer_details.photo_ktp, true)" class="cursor-pointer" />
                            <b-img id="edit-ktp-preview-default" height="250" width="300" v-else src="/img/img-preview.png" fluid thumbnail />
                        </b-form-group>
                        <b-form-group>
                            <label for="edit-ktp">File KTP / SIM<span style="color:red;">*</span></label>
                            <b-form-file id="edit-ktp" v-model="edit.ktp" placeholder="Pilih file..." accept="image/*" @input="edit.ktp = $event" @change="(e) => onFileChangeEdit(e, 'ktpPreview')"></b-form-file>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group label="Preview Surat Pernyataan">
                            <b-img id="edit-statement-letter-preview" height="250" width="300" v-if="edit.statementLetterPreview" :src="edit.statementLetterPreview" fluid thumbnail
                                @click="showImagePreview(edit.statementLetterPreview)" class="cursor-pointer" />
                            <b-img id="edit-statement-letter-placeholder" height="250" width="300" v-else-if="activeItem.customer_details && activeItem.customer_details.photo_statement_letter" :src="$BASE_FILE_PATH + activeItem.customer_details.photo_statement_letter" fluid thumbnail
                                @click="showImagePreview($BASE_FILE_PATH + activeItem.customer_details.photo_statement_letter, true)" class="cursor-pointer" />
                            <b-img id="edit-statement-letter-default" height="250" width="300" v-else src="/img/img-preview.png" fluid thumbnail />
                        </b-form-group>
                        <b-form-group>
                            <label for="edit-statement-letter">File Surat Pernyataan<span style="color:red;">*</span></label>
                            <b-form-file id="edit-statement-letter" v-model="edit.statementLetter" placeholder="Pilih file..." accept="image/*" @input="edit.statementLetter = $event" @change="(e) => onFileChangeEdit(e, 'statementLetterPreview')"></b-form-file>
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <h5 class="mb-0">Alamat Rumah</h5>
                        <hr />
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-house-province">
                            <label for="house-province">Provinsi<span style="color:red;">*</span></label>
                                <multiselect id="house-province" :internal-search="true" label="name" track-by="id" v-model="edit.houseProvince"
                                    :options="optProvince" :disabled="optProvince.length == 0"
                                    @input="getCity(edit.houseProvince.id)" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-house-city">
                            <label for="house-city">Kabupaten / Kota<span style="color:red;">*</span></label>
                                <multiselect id="house-city" :internal-search="true" label="name" track-by="id"
                                    :disabled="optCity.length == 0" v-model="edit.houseCity" :options="optCity"
                                    @input="getDistrict(edit.houseCity.id)" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-house-district">
                            <label for="house-district">Kecamatan<span style="color:red;">*</span></label>
                                <multiselect id="house-district" :internal-search="true" label="name" track-by="id"
                                    :disabled="optDistrict.length == 0" text-field="name" value-field="id"
                                    v-model="edit.houseDistrict" :options="optDistrict" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-house-postal-code">Kode Pos<span style="color:red;">*</span></label>
                            <b-input id="edit-housePostalCode" v-model="edit.housePostalCode" maxlength="5" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="edit-house-address">Alamat<span style="color:red;">*</span></label>
                            <b-form-textarea id="edit-house-address" v-model="edit.houseAddress" rows="3" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <div class="d-flex align-middle">
                            <h5 class="mb-0 mr-3 my-auto">Alamat Domisili</h5>
                            <b-button id="btn-copy-address-home-domicile-edit" variant="primary" @click="copyAddressHomeDomicileEdit">Salin dari Alamat
                                Rumah</b-button>
                        </div>
                        <hr />
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-domicile-province">
                            <label for="domicile-province">Provinsi<span style="color:red;">*</span></label>
                                <multiselect id="domicile-province" :internal-search="true" label="name" track-by="id"
                                    v-model="edit.domicileProvince" :options="optProvince"
                                    @input="getDomicileCity(edit.domicileProvince.id)"
                                    :disabled="optProvince.length == 0" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-domicile-city">
                            <label for="domicile-city">Kabupaten / Kota<span style="color:red;">*</span></label>
                                <multiselect id="domicile-city" :internal-search="true" label="name" track-by="id" v-model="edit.domicileCity"
                                    :options="domicileOptCity" :disabled="domicileOptCity.length == 0"
                                    @input="getDomicileDistrict(edit.domicileCity.id)" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-domicile-district">
                            <label for="domicile-district">Kecamatan<span style="color:red;">*</span></label>
                                <multiselect id="domicile-district" :internal-search="true" label="name" track-by="id"
                                    :disabled="domicileOptDistrict.length == 0" v-model="edit.domicileDistrict"
                                    :options="domicileOptDistrict" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-domicile-postal-code">Kode Pos<span style="color:red;">*</span></label>
                            <b-input id="edit-domicile-postal-code" v-model="edit.domicilePostalCode" maxlength="5" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="edit-domicile-address">Alamat<span style="color:red;">*</span></label>
                            <b-form-textarea id="edit-domicile-address" v-model="edit.domicileAddress" rows="3" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <div class="d-flex align-middle">
                            <h5 class="mb-0 mr-3 my-auto">Data Toko</h5>
                            <b-button id="btn-copy-address-home-store-edit" variant="primary" @click="copyAddressHomeStoreEdit">Salin dari Alamat
                                Rumah</b-button>
                        </div>
                        <hr />
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-store-province">
                            <label for="store-province">Provinsi<span style="color:red;">*</span></label>
                                <multiselect id="store-province" :internal-search="true" label="name" track-by="id" v-model="edit.storeProvince"
                                    :options="optProvince" :disabled="optProvince.length == 0"
                                    @input="getStoreCity(edit.storeProvince.id)" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-store-city">
                            <label for="store-city">Kabupaten / Kota<span style="color:red;">*</span></label>
                                <multiselect id="store-city" :internal-search="true" label="name" track-by="id" v-model="edit.storeCity"
                                    :options="storeOptCity" :disabled="storeOptCity.length == 0"
                                    @input="getStoreDistrict(edit.storeCity.id)" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group id="edit-store-district">
                            <label for="store-district">Kecamatan<span style="color:red;">*</span></label>
                                <multiselect id="store-district" :internal-search="true" label="name" track-by="id"
                                    :disabled="storeOptDistrict.length == 0" v-model="edit.storeDistrict"
                                    :options="storeOptDistrict" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group>
                            <label for="edit-store-postal-code">Kode Pos<span style="color:red;">*</span></label>
                            <b-input id="edit-store-postal-code" v-model="edit.storePostalCode" maxlength="5" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <b-form-group>
                            <label for="edit-store-address">Alamat<span style="color:red;">*</span></label>
                            <b-form-textarea id="edit-store-address" v-model="edit.storeAddress" rows="3" />
                        </b-form-group>
                    </b-col>

                    <b-col md="12">
                        <h5 class="mb-0">Akun Sosial Media</h5>
                        <hr />
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="IG">
                            <b-input id="edit-ig" v-model="edit.ig" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="TikTok">
                            <b-input id="edit-tiktok" v-model="edit.tiktok" maxlength="100" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6">
                        <b-form-group label="Facebook">
                            <b-input id="edit-facebook" v-model="edit.facebook" maxlength="100" />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-4 text-right">
                    <b-button id="btn-confirm-edit" variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                        {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                    </b-button>
                </div>
            </template>

            <div id="loading-spinner" v-else class="text-center mb-3 d-flex justify-content-center">
                <b-spinner label="Loading..."></b-spinner>
            </div>

        </b-modal>
        <b-modal id="m-edit-piutang" title="Edit Piutang" no-close-on-backdrop no-close-on-esc hide-footer>
            Mengubah customer <strong>{{ activeItem.name }}</strong>
            <b-form-group id="edit-piutang-group" class="mt-4 d-flex">
            <b-form-checkbox id="edit-piutang-checkbox" v-model="edit.piutang" class="mt-2">Piutang</b-form-checkbox>
            </b-form-group>
            <b-form-group id="edit-limit-piutang-group" v-if="edit.piutang" label="Limit Piutang">
            <b-input-group id="edit-limit-piutang-input-group" prepend="Rp.">
                <b-form-input id="edit-limit-piutang-input" v-model="edit.limitPiutang" maxlength="50"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                @input="sanitizeLimitPiutang" />
            </b-input-group>
            </b-form-group>
            <div id="edit-piutang-buttons" class="mt-4 text-right">
            <b-button id="btn-confirm-piutang" variant="primary" :disabled="isSubmitting" @click="confirmPiutang">
                {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
            </b-button>
            </div>
        </b-modal>
        <b-modal id="m-download" title="Master Customer" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div id="download-status-preparing" v-if="status == 0">
            Menyiapkan file Excel, mohon menunggu...
            </div>
            <div id="download-status-failed" v-else-if="status == -1">
            Gagal menyiapkan file Excel.
            </div>
            <div id="download-status-ready" v-else>
            File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
            <div id="download-button-container" class="mt-2">
                <a id="download-link" :href="$BASE_FILE_PATH + path" download>
                <b-button id="btn-download-master-customer" variant="primary">
                    <i class="fa fa-download mr-2" />Download Master Customer
                </b-button>
                </a>
            </div>
            </div>
        </b-modal>

        <b-modal id="image-preview-modal" size="lg" centered hide-footer title="Preview Gambar">
            <div class="text-center">
                <b-img :src="previewImageSrc" fluid />
            </div>
            <div v-if="isImageUploaded">
                <b-button variant="primary" class="mt-3" block @click="openImageInNewTab(previewImageSrc)">
                    Buka foto ditab baru
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-confirm-blacklist"
            :title="activeItem.is_blacklisted ? 'Konfirmasi Lepas Blacklist' : 'Konfirmasi Blacklist'"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            Apakah anda yakin ingin {{ activeItem.is_blacklisted ? 'Lepas Blacklist' : 'blacklist' }} customer <strong>{{ activeItem.name }}</strong>?
            <b-form-group label="Catatan Blacklist">
                <b-input
                    v-model="blacklist.note"
                    maxlength="200"
                    :placeholder="activeItem.is_blacklisted ? 'Input alasan lepas blacklist' : 'Input alasan blacklist'"
                />
            </b-form-group>
            <div class="text-right mt-4">
                <b-button
                    :variant="activeItem.is_blacklisted ? 'success' : 'danger'"
                    :disabled="isSubmitting"
                    @click="updateBlacklist"
                >
                    {{ activeItem.is_blacklisted ? 'Lepas Blacklist' : 'Blacklist' }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-confirm-allow-manual-payment"
            title="Konfirmasi Pembayaran Manual"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
        {{ allowManualPayment.is_allowed ? 'Ijinkan Pembayaran Manual' : 'Blokir Pembayaran Manual' }} customer <strong>{{ activeItem.name }}</strong>?
            <div class="text-right mt-4">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAllowManualPayment">
                    {{ allowManualPayment.is_allowed ? 'Ijinkan Pembayaran Manual' : 'Blokir Pembayaran Manual' }}
                </b-button>
            </div>
        </b-modal>

        <b-modal
            id="m-confirm-reset-pin"
            title="Konfirmasi Reset PIN"
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            Apakah anda yakin ingin mereset PIN customer <strong>{{ activeItem.name }}</strong>?
            <div class="text-right mt-4">
                <b-button variant="info" :disabled="isSubmitting" @click="confirmResetPin">
                    Reset PIN
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-filter" title="Filter Pencarian" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Nama">
                        <b-form-input v-model="filter.name" maxlength="50" placeholder="Cari Nama..."/>
                    </b-form-group>
                </b-col>
                <b-col md="6">  
                    <b-form-group label="No. Handphone">
                        <b-form-input v-model="filter.phone" maxlength="50" placeholder="Cari No. Handphone..."/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Kota">
                        <multiselect :multiple="false" v-model="filter.city" label="name"
                            track-by="id" :internal-search="true" :options="optCity" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Provinsi">
                        <multiselect :multiple="false" v-model="filter.province" label="name"
                            track-by="id" :internal-search="true" :options="optProvince" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Hutang / Piutang">
                        <b-form-select id="filter-credit-debt" v-model="filter.creditDebt" :options="optCreditDebt" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Limit">
                        <b-form-select id="filter-limit-over" v-model="filter.limitOver" :options="optLimitOver" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Blacklist">
                        <b-form-select id="filter-blacklist" v-model="filter.isBlacklisted" :options="optBlacklist" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Allow Manual Payment">
                        <b-form-select id="filter-allow-manual-payment" v-model="filter.allowManualPayment" :options="optAllowManualPayment" />
                    </b-form-group>
                </b-col>
            </b-row>

            <div class="mt-4 text-right">
                <b-button variant="danger" @click="clearFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import helper from '@/helper'
import EnumPermissions from '@/shared/enum-permissions'

export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,
            isGenerateLoading: false,
            generatingTokenId: null,

            filter: {
                name: "",
                phone: "",
                province: null,
                city: null,
                creditDebt: -1,
                limitOver: -1,
                isBlacklisted: -1,
                allowManualPayment: -1
            },

            input: {
                name: "",
                phone: "",
                birthday: "",
                whatsapp: "",
                email: "",
                nik: "",
                ktp: null,
                ktpPreview: null,
                houseProvince: "",
                houseCity: "",
                houseDistrict: "",
                housePostalCode: "",
                houseAddress: "",
                domicileProvince: "",
                domicileCity: "",
                domicileDistrict: "",
                domicilePostalCode: "",
                domicileAddress: "",
                storeName: "",
                storeProvince: "",
                storeCity: "",
                storeDistrict: "",
                storePostalCode: "",
                storeAddress: "",
                ig: "",
                tiktok: "",
                facebook: "",
                statementLetter: null,
                statementLetterPreview: null
            },

            edit: {
                name: "",
                phone: "",
                birthday: "",
                whatsapp: "",
                email: "",
                nik: "",
                ktp: null,
                ktpPreview: null,
                overlimit: false,
                piutang: false,
                limitPiutang: 0,
                houseProvince: "",
                houseCity: "",
                houseDistrict: "",
                housePostalCode: "",
                houseAddress: "",
                domicileProvince: "",
                domicileCity: "",
                domicileDistrict: "",
                domicilePostalCode: "",
                domicileAddress: "",
                storeName: "",
                storeProvince: "",
                storeCity: "",
                storeDistrict: "",
                storePostalCode: "",
                storeAddress: "",
                ig: "",
                tiktok: "",
                facebook: "",
                statementLetter: null,
                statementLetterPreview: null
            },

            blacklist: {
                note: "",
                is_blacklisted: false
            },

            allowManualPayment: {   
                is_allowed: false
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "name", label: "Nama Toko", sortable: true },
                { key: "credit", label: "Piutang", sortable: true },
                { key: "debt", label: "Hutang", sortable: true },
                { key: "last_payment", label: "Pembayaran terakhir", sortable: true },
                { key: "limit_credit", label: "Limit Piutang", sortable: true },
                { key: "status", label: "Status", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            activeId: 0,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optCreditDebt: [
                { value: -1, text: "-- Semua --" },
                { value: 1, text: "Memiliki Piutang" },
                { value: 2, text: "Memiliki Hutang" }
            ],

            optBlacklist: [
                { value: -1, text: "-- Semua --" },
                { value: 1, text: "Blacklist" },
                { value: 0, text: "Tidak Blacklist" }
            ],

            optAllowManualPayment: [
                { value: -1, text: "-- Semua --" },
                { value: 1, text: "Iya" },
                { value: 0, text: "Tidak" }
            ],

            status: 0,

            optLimitOver: [
                { value: -1, text: "-- Semua --" },
                { value: 1, text: "Memiliki Limit" },
            ],

            optProvince: [],

            optCity: [],
            domicileOptCity: [],
            storeOptCity: [],

            optDistrict: [],
            domicileOptDistrict: [],
            storeOptDistrict: [],

            isLoading: false,
            previewImageSrc: "",
            isImageUploaded: false,


        }
    },

    computed: {
        isCustomerEditPiutang() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_EDIT_PIUTANG.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerView() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_VIEW.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerCreate() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_CREATE.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerEdit() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_EDIT.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerResetPin() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_RESET_PIN.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerEditOverlimit() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_EDIT_OVERLIMIT.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerBlacklist() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_BLACKLIST.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

        isCustomerAllowManualPayment() {
            return helper.checkRoleNumber(EnumPermissions.CUSTOMER_ALLOW_MANUAL_PAYMENT.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        },

    },

    methods: {
        showModalFilter() {
            this.$bvModal.show("m-filter")
        },

        openConfirmAllowManualPayment(item, isAllowed) {
            this.activeItem = item
            this.allowManualPayment.is_allowed = isAllowed
            this.$bvModal.show("m-confirm-allow-manual-payment")
        },

        openConfirmResetPin(item) {
            this.activeItem = item
            this.$bvModal.show("m-confirm-reset-pin")
        },

        confirmResetPin() {
            if (!this.isCustomerResetPin) return
            
            this.isSubmitting = true
            this.$axios.patch("customer/reset-pin/" + this.activeItem.id).then(() => {
                this.$helper.toastSuccess(this, "PIN customer berhasil direset!")
                this.$bvModal.hide("m-confirm-reset-pin")
                this.getItems(this.currentPage)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        confirmAllowManualPayment() {
            this.isSubmitting = true
            
            const payload = {
                customer_id: this.activeItem.id,
                allow_manual_payment: this.allowManualPayment.is_allowed ? 1 : 0
            }

            this.$axios.patch("customer/update-allow-manual-payment", payload).then(() => {
                this.$helper.toastSuccess(this, this.allowManualPayment.is_allowed ? 'Customer berhasil diijinkan pembayaran manual!' : 'Customer berhasil diblokir dari pembayaran manual!')
                this.$bvModal.hide("m-confirm-allow-manual-payment")
                this.getItems(this.currentPage)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        openConfirmBlacklist(item, isBlacklisted) {
            this.activeItem = item
            this.blacklist.note = ""
            this.blacklist.is_blacklisted = isBlacklisted
            this.$bvModal.show("m-confirm-blacklist")
        },

        updateBlacklist() {
            if (this.$helper.isBlank(this.blacklist.note)) {
                this.$helper.toastError(this, `Alasan ${this.blacklist.is_blacklisted == 1 ? 'blacklist' : 'lepas blacklist'} tidak boleh kosong!`)
                return
            }

            this.isSubmitting = true

            const payload ={
                customer_id: this.activeItem.id,
                is_blacklisted: this.blacklist.is_blacklisted ? 1 : 0,
                notes: this.blacklist.note
            }

            this.$axios.patch("customer/update-blacklist-status", payload).then(() => {
                this.$helper.toastSuccess(this, "Customer berhasil diblacklist!")
                this.$bvModal.hide("m-confirm-blacklist")
                this.getItems(this.currentPage)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },
        
        limitCreditCheck(val) {
            return val.allow_piutang ? `Rp. ${this.$helper.formatThousand(val.limit_credit)}` : "Tidak boleh Piutang"
        },
        init() {

            this.initStatus = 0
            let getItems = this.getItems()
            let getProvince = this.getPronvince();

            Promise.all([getItems, getProvince]).then(() => {
                this.initStatus = 1
            })
                .catch(() => {
                    this.initStatus = -1
                })

        },

        validateObject(obj) {
            if (!obj.id || !obj.name) {
                return false;
            }
            return true;
        },

        confirmCreate() {



            if (this.$helper.isBlank(this.input.name)) {
                this.$helper.toastError(this, "Nama customer tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.phone)) {
                this.$helper.toastError(this, "No. Handphone tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.nik)) {
                this.$helper.toastError(this, "NIK / No. KTP tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.birthday)) {
                this.$helper.toastError(this, "Tanggal lahir tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.ktp)) {
                this.$helper.toastError(this, "Foto KTP tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.statementLetter)) {
                this.$helper.toastError(this, "Foto surat pernyataan tidak boleh kosong!")
                return
            }

            if (this.input.ktp instanceof File) {
                if (this.input.ktp.type != "image/jpeg" && this.input.ktp.type != "image/png") {
                    this.$helper.toastError(this, "Foto KTP harus berformat JPG atau PNG!")
                    return
                }
            }

            if (this.input.statementLetter instanceof File) {
                if (this.input.statementLetter.type != "image/jpeg" && this.input.statementLetter.type != "image/png") {
                    this.$helper.toastError(this, "Foto surat pernyataan harus berformat JPG atau PNG!")
                    return
                }
            }

            if (!this.validateObject(this.input.houseProvince)) {
                this.$helper.toastError(this, "Provinsi alamat rumah tidak boleh kosong!")
            }

            if (!this.validateObject(this.input.houseCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat rumah tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.houseDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat rumah tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.houseAddress)) {
                this.$helper.toastError(this, "Alamat alamat rumah tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.housePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat rumah tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.domicileProvince)) {
                this.$helper.toastError(this, "Provinsi alamat domisili tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.domicileCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat domisili tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.domicileDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.domicileAddress)) {
                this.$helper.toastError(this, "Alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.domicilePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.storeName)) {
                this.$helper.toastError(this, "Nama toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.storeProvince)) {
                this.$helper.toastError(this, "Provinsi alamat toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.storeCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.input.storeDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat toko tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.storePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat toko tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.input.storeAddress)) {
                this.$helper.toastError(this, "Alamat toko tidak boleh kosong!")
                return
            }

            let isConfirmed = confirm("Simpan customer baru ini?")
            if (!isConfirmed) return

            let payload = new FormData()

            payload.append("name", this.input.name)
            payload.append("phone", this.input.phone)
            payload.append("address", this.input.houseAddress)
            payload.append("ktp", this.input.nik)
            payload.append("photo_ktp", this.input.ktp)
            payload.append("photo_statement_letter", this.input.statementLetter)
            payload.append("customer_details", JSON.stringify({
                ktp: this.input.nik,
                birth_date: this.input.birthday,
                phone_number: this.input.phone,
                whatsapp_number: this.input.whatsapp,
                email: this.input.email,
                instagram: this.input.ig,
                facebook: this.input.facebook,
                tiktok: this.input.tiktok
            }))
            payload.append("customer_addr", JSON.stringify([
                {
                    province_id: this.input.houseProvince.id,
                    city_id: this.input.houseCity.id,
                    districts_id: this.input.houseDistrict.id,
                    address_type: 1,
                    address: this.input.houseAddress,
                    postal_code: this.input.housePostalCode
                },
                {
                    province_id: this.input.domicileProvince.id,
                    city_id: this.input.domicileCity.id,
                    districts_id: this.input.domicileDistrict.id,
                    address_type: 2,
                    address: this.input.domicileAddress,
                    postal_code: this.input.domicilePostalCode
                },
                {
                    province_id: this.input.storeProvince.id,
                    city_id: this.input.storeCity.id,
                    districts_id: this.input.storeDistrict.id,
                    address_type: 3,
                    address: this.input.storeAddress,
                    postal_code: this.input.storePostalCode,
                    store_name: this.input.storeName
                }
            ]))

            this.isSubmitting = true
            this.$axios.post("customer", payload).then(() => {

                this.$helper.toastSuccess(this, "Customer baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.clearInput()
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        async prepareEdit(item) {
            this.clearEdit()
            this.$bvModal.show("m-edit")
            this.isLoading = true
            await this.getDetailCustomer(item.id)
            this.isLoading = false

        },

        preparePiutang(item) {
            this.activeItem = item
            this.edit.piutang = item.allow_piutang == 1
            this.edit.limitPiutang = item.limit_credit
            this.$bvModal.show("m-edit-piutang")
            this.sanitizeLimitPiutang()
        },

        confirmEdit() {


            if (this.$helper.isBlank(this.edit.name)) {
                this.$helper.toastError(this, "Nama customer tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.phone)) {
                this.$helper.toastError(this, "No. Handphone tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.nik)) {
                this.$helper.toastError(this, "NIK / No. KTP tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.birthday)) {
                this.$helper.toastError(this, "Tanggal lahir tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.ktp) && !this.activeItem.customer_details.photo_ktp) {
                this.$helper.toastError(this, "Foto KTP tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.statementLetter) && !this.activeItem.customer_details.photo_statement_letter) {
                this.$helper.toastError(this, "Foto surat pernyataan tidak boleh kosong!")
                return
            }

            if (this.edit.ktp instanceof File) {
                if (this.edit.ktp.type != "image/jpeg" && this.edit.ktp.type != "image/png") {
                    this.$helper.toastError(this, "Foto KTP harus berformat JPG atau PNG!")
                    return
                }
            }

            if (this.edit.statementLetter instanceof File) {
                if (this.edit.statementLetter.type != "image/jpeg" && this.edit.statementLetter.type != "image/png") {
                    this.$helper.toastError(this, "Foto surat pernyataan harus berformat JPG atau PNG!")
                    return
                }
            }

            if (!this.validateObject(this.edit.houseProvince)) {
                this.$helper.toastError(this, "Provinsi alamat rumah tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.houseCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat rumah tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.houseDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat rumah tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.houseAddress)) {
                this.$helper.toastError(this, "Alamat alamat rumah tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.housePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat rumah tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.domicileProvince)) {
                this.$helper.toastError(this, "Provinsi alamat domisili tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.domicileCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat domisili tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.domicileDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.domicileAddress)) {
                this.$helper.toastError(this, "Alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.domicilePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat domisili tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.storeName)) {
                this.$helper.toastError(this, "Nama toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.storeProvince)) {
                this.$helper.toastError(this, "Provinsi alamat toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.storeCity)) {
                this.$helper.toastError(this, "Kabupaten / Kota alamat toko tidak boleh kosong!")
                return
            }

            if (!this.validateObject(this.edit.storeDistrict)) {
                this.$helper.toastError(this, "Kecamatan alamat toko tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.storePostalCode)) {
                this.$helper.toastError(this, "Kode pos alamat toko tidak boleh kosong!")
                return
            }

            if (this.$helper.isBlank(this.edit.storeAddress)) {
                this.$helper.toastError(this, "Alamat toko tidak boleh kosong!")
                return
            }

            let isConfirmed = confirm("Simpan perubahan customer ini?")
            if (!isConfirmed) return

            let payload = new FormData()

            payload.append("name", this.edit.name)
            payload.append("phone", this.edit.phone)
            payload.append("address", this.edit.houseAddress)
            payload.append("ktp", this.edit.nik)
            payload.append("store_name", this.edit.storeName)
            if (this.edit.ktp instanceof File) {
                payload.append("photo_ktp", this.edit.ktp)
            }
            if (this.edit.statementLetter instanceof File) {
                payload.append("photo_statement_letter", this.edit.statementLetter)
            }
            payload.append("customer_details", JSON.stringify({
                ktp: this.edit.nik,
                birth_date: this.edit.birthday,
                phone_number: this.edit.phone,
                whatsapp_number: this.edit.whatsapp,
                email: this.edit.email,
                instagram: this.edit.ig,
                facebook: this.edit.facebook,
                tiktok: this.edit.tiktok
            }))

            payload.append("customer_addr", JSON.stringify([
                {
                    province_id: this.edit.houseProvince.id,
                    city_id: this.edit.houseCity.id,
                    districts_id: this.edit.houseDistrict.id,
                    address_type: 1,
                    address: this.edit.houseAddress,
                    postal_code: this.edit.housePostalCode
                },
                {
                    province_id: this.edit.domicileProvince.id,
                    city_id: this.edit.domicileCity.id,
                    districts_id: this.edit.domicileDistrict.id,
                    address_type: 2,
                    address: this.edit.domicileAddress,
                    postal_code: this.edit.domicilePostalCode
                },
                {
                    province_id: this.edit.storeProvince.id,
                    city_id: this.edit.storeCity.id,
                    districts_id: this.edit.storeDistrict.id,
                    address_type: 3,
                    address: this.edit.storeAddress,
                    postal_code: this.edit.storePostalCode,
                    store_name: this.edit.storeName
                }
            ])
            )

            this.isSubmitting = true
            this.$axios.post("customer/" + this.activeItem.id, payload).then(() => {

                this.$helper.toastSuccess(this, "Customer berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (this.filter.isBlacklisted != -1) {
                param += "&isBlacklisted=" + this.filter.isBlacklisted
            }

            if (this.filter.allowManualPayment != -1) {
                param += "&allowManualPayment=" + this.filter.allowManualPayment
            }

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if (!this.$helper.isBlank(this.filter.phone)) {
                param += "&filterPhone=" + this.filter.phone
            }

            if (this.filter.creditDebt != -1) {
                param += "&filterCreditDebt=" + this.filter.creditDebt
            }

            if (this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            if (this.filter.limitOver == 2) {
                param += "&filterOverLimit=" + true
            }

            if (this.filter.limitOver == 1) {
                param += "&filterPiutang=" + true
            }

            if (this.filter.province) {
                param += "&filterProvinceId=" + this.filter.province.id
            }

            if (this.filter.city) {
                param += "&filterCityId=" + this.filter.city.id
            }

            return this.$axios.get("customer" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listCustomerFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        downloadMasterCustomer() {

            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("customer/download-excel-master", this.filter).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        sanitizeLimitPiutang() {
            let cleaned = String(this.edit.limitPiutang).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.edit.limitPiutang = res
        },

        confirmPiutang() {


            const isConfirmed = confirm("Simpan perubahan piutang customer ini?")
            if (!isConfirmed) return

            let payload = {
                allow_piutang: this.edit.piutang ? 1 : 0,
                limit_credit: this.$helper.toNumber(this.edit.limitPiutang)
            }

            this.isSubmitting = true
            this.$axios.post("customer/allow-limit-piutang/" + this.activeItem.id, payload).then(() => {

                this.$helper.toastSuccess(this, "Piutang customer berhasil diubah!")
                this.$bvModal.hide("m-edit-piutang")
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        async getPronvince() {
            this.optProvince = []
            this.optCity = []
            this.optDistrict = []
            await this.$axios.get("catalog/province").then(res => {
                this.optProvince = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getCity(provinceId) {
            this.optDistrict = [],
                this.input.houseCity = {}
            this.input.houseDistrict = {}
            this.edit.houseCity = {}
            this.edit.houseDistrict = {}
            await this.$axios.get("catalog/city/" + provinceId).then(res => {
                this.optCity = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getDomicileCity(provinceId) {
            this.domicileOptDistrict = []
            this.input.domicileCity = {}
            this.input.domicileDistrict = {}
            this.edit.domicileCity = {}
            this.edit.domicileDistrict = {}
            await this.$axios.get("catalog/city/" + provinceId).then(res => {
                this.domicileOptCity = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getStoreCity(provinceId) {
            this.storeOptDistrict = []
            this.input.storeCity = {}
            this.input.storeDistrict = {}
            this.edit.storeCity = {}
            this.edit.storeDistrict = {}
            await this.$axios.get("catalog/city/" + provinceId).then(res => {
                this.storeOptCity = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getDistrict(cityId) {
            this.input.houseDistrict = {}
            this.edit.houseDistrict = {}
            await this.$axios.get("catalog/districts/" + cityId).then(res => {
                this.optDistrict = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getDomicileDistrict(cityId) {
            this.input.domicileDistrict = {}
            this.edit.domicileDistrict = {}
            await this.$axios.get("catalog/districts/" + cityId).then(res => {
                this.domicileOptDistrict = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        async getStoreDistrict(cityId) {
            this.input.storeDistrict = {}
            this.edit.storeDistrict = {}
            await this.$axios.get("catalog/districts/" + cityId).then(res => {
                this.storeOptDistrict = res.data.data
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
        },

        handleModalCreateCustomer() {
            this.getPronvince()
            this.$bvModal.show("m-create")
        },

        copyAddressHomeDomicile() {
            this.input.domicileProvince = this.input.houseProvince
            this.input.domicileCity = this.input.houseCity
            this.input.domicileDistrict = this.input.houseDistrict
            this.input.domicilePostalCode = this.input.housePostalCode
            this.input.domicileAddress = this.input.houseAddress
            this.domicileOptCity = this.optCity
            this.domicileOptDistrict = this.optDistrict
        },

        copyAddressHomeStore() {
            this.input.storeProvince = this.input.houseProvince
            this.input.storeCity = this.input.houseCity
            this.input.storeDistrict = this.input.houseDistrict
            this.input.storePostalCode = this.input.housePostalCode
            this.input.storeAddress = this.input.houseAddress
            this.storeOptCity = this.optCity
            this.storeOptDistrict = this.optDistrict
        },

        async copyAddressHomeDomicileEdit() {
            this.edit.domicileProvince = this.edit.houseProvince
            this.edit.domicilePostalCode = this.edit.housePostalCode
            this.edit.domicileAddress = this.edit.houseAddress
            this.domicileOptCity = this.optCity
            this.domicileOptDistrict = this.optDistrict
            this.edit.domicileCity = this.edit.houseCity
            this.edit.domicileDistrict = this.edit.houseDistrict
        },

        async copyAddressHomeStoreEdit() {
            this.edit.storeProvince = this.edit.houseProvince
            this.edit.storePostalCode = this.edit.housePostalCode
            this.edit.storeAddress = this.edit.houseAddress
            this.storeOptCity = this.optCity
            this.storeOptDistrict = this.optDistrict
            this.edit.storeCity = this.edit.houseCity
            this.edit.storeDistrict = this.edit.houseDistrict
        },

        async getDetailCustomer(id) {
            try {
                this.isBusy = true;
                this.activeId = id;
                this.activeItem = {};
                await this.getPronvince(); // Tunggu sampai getPronvince selesai

                const res = await this.$axios.get("customer/" + id); // Tunggu sampai data customer didapatkan
                this.activeItem = res.data.data;

                this.edit.name = this.activeItem.name_customer;

                if (this.activeItem.customer_details) {
                    this.edit.phone = this.activeItem.customer_details.phone_number;
                    this.edit.birthday = this.activeItem.customer_details.birth_date;
                    this.edit.whatsapp = this.activeItem.customer_details.whatsapp_number;
                    this.edit.email = this.activeItem.customer_details.email;
                    this.edit.nik = this.activeItem.customer_details.ktp;

                    // Social Media
                    this.edit.ig = this.activeItem.customer_details.instagram;
                    this.edit.tiktok = this.activeItem.customer_details.tiktok;
                    this.edit.facebook = this.activeItem.customer_details.facebook;
                }

                if (this.activeItem.customer_addr.length > 0) {
                    // House Address
                    this.edit.houseProvince = this.optProvince.find(x => x.id == this.activeItem.customer_addr[0].province_id) || {};
                    if (this.edit.houseProvince.id) {
                        await this.getCity(this.edit.houseProvince.id); // Tunggu sampai getCity selesai
                    }

                    this.edit.houseCity = this.optCity.find(x => x.id == this.activeItem.customer_addr[0].city_id) || {};
                    if (this.edit.houseCity.id) {
                        await this.getDistrict(this.edit.houseCity.id); // Tunggu sampai getDistrict selesai
                    }

                    this.edit.houseDistrict = this.optDistrict.find(x => x.id == this.activeItem.customer_addr[0].districts_id) || {};
                    this.edit.housePostalCode = this.activeItem.customer_addr[0].postal_code;
                    this.edit.houseAddress = this.activeItem.customer_addr[0].address;

                    // Domicile Address
                    this.edit.domicileProvince = this.optProvince.find(x => x.id == this.activeItem.customer_addr[1].province_id) || {};
                    if (this.edit.domicileProvince.id) {
                        await this.getDomicileCity(this.edit.domicileProvince.id); // Tunggu sampai getDomicileCity selesai
                    }

                    this.edit.domicileCity = this.domicileOptCity.find(x => x.id == this.activeItem.customer_addr[1].city_id) || {};
                    if (this.edit.domicileCity.id) {
                        await this.getDomicileDistrict(this.edit.domicileCity.id); // Tunggu sampai getDomicileDistrict selesai
                    }

                    this.edit.domicileDistrict = this.domicileOptDistrict.find(x => x.id == this.activeItem.customer_addr[1].districts_id) || {};
                    this.edit.domicilePostalCode = this.activeItem.customer_addr[1].postal_code;
                    this.edit.domicileAddress = this.activeItem.customer_addr[1].address;

                    this.edit.storeName = this.activeItem.name;

                    // Store Address
                    this.edit.storeProvince = this.optProvince.find(x => x.id == this.activeItem.customer_addr[2].province_id) || {};
                    if (this.edit.storeProvince.id) {
                        await this.getStoreCity(this.edit.storeProvince.id); // Tunggu sampai getStoreCity selesai
                    }

                    this.edit.storeCity = this.storeOptCity.find(x => x.id == this.activeItem.customer_addr[2].city_id) || {};
                    if (this.edit.storeCity.id) {
                        await this.getStoreDistrict(this.edit.storeCity.id); // Tunggu sampai getStoreDistrict selesai
                    }

                    this.edit.storeDistrict = this.storeOptDistrict.find(x => x.id == this.activeItem.customer_addr[2].districts_id) || {};
                    this.edit.storePostalCode = this.activeItem.customer_addr[2].postal_code;
                    this.edit.storeAddress = this.activeItem.customer_addr[2].address;

                }



            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isBusy = false;
            }
        },


        checkFileTypes(file) {
            if (file.type !== "image/jpeg" && file.type !== "image/png") {
                this.$helper.toastError(this, "File harus berupa gambar dengan format JPG atau PNG!")
                return false
            }
            return true
        },

        clearInput() {
            this.input.name = ""
            this.input.phone = ""
            this.input.birthday = ""
            this.input.whatsapp = ""
            this.input.email = ""
            this.input.nik = ""
            this.input.ktp = null
            this.input.ktpPreview = null
            this.input.houseProvince = ""
            this.input.houseCity = ""
            this.input.houseDistrict = ""
            this.input.housePostalCode = ""
            this.input.houseAddress = ""
            this.input.domicileProvince = ""
            this.input.domicileCity = ""
            this.input.domicileDistrict = ""
            this.input.domicilePostalCode = ""
            this.input.domicileAddress = ""
            this.input.storeName = ""
            this.input.storeProvince = ""
            this.input.storeCity = ""
            this.input.storeDistrict = ""
            this.input.storePostalCode = ""
            this.input.storeAddress = ""
            this.input.ig = ""
            this.input.tiktok = ""
            this.input.facebook = ""
        },

        clearEdit() {
            this.edit.name = ""
            this.edit.phone = ""
            this.edit.birthday = ""
            this.edit.whatsapp = ""
            this.edit.email = ""
            this.edit.nik = ""
            this.edit.ktp = null
            this.edit.ktpPreview = null
            this.edit.statementLetter = null
            this.edit.statementLetterPreview = null
            this.edit.houseProvince = ""
            this.edit.houseCity = ""
            this.edit.houseDistrict = ""
            this.edit.housePostalCode = ""
            this.edit.houseAddress = ""
            this.edit.domicileProvince = ""
            this.edit.domicileCity = ""
            this.edit.domicileDistrict = ""
            this.edit.domicilePostalCode = ""
            this.edit.domicileAddress = ""
            this.edit.storeName = ""
            this.edit.storeProvince = ""
            this.edit.storeCity = ""
            this.edit.storeDistrict = ""
            this.edit.storePostalCode = ""
            this.edit.storeAddress = ""
            this.edit.ig = ""
            this.edit.tiktok = ""
            this.edit.facebook = ""
        },

        clearFilter() {
            this.filter = {
                name: "",
                phone: "",
                province: null,
                city: null,
                creditDebt: -1,
                limitOver: -1,
                isBlacklisted: -1,
                allowManualPayment: -1
            }
            this.getItems(this.currentPage)
        },

        onFileChangeEdit(e, key) {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.edit[key] = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },

        onFileChangeInput(e, key) {
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.input[key] = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        copyPaymentUrl(item) {
            navigator.clipboard.writeText(item.self_payment_url)
                .then(() => {
                    this.$helper.toastSuccess(this, "URL pembayaran berhasil disalin!");
                })
                .catch(error => this.$helper.parseError(this, error));
        },
        showImagePreview(imageSrc, isImageUploaded = false) {
            if (!imageSrc) return;
            this.previewImageSrc = imageSrc;
            this.isImageUploaded = isImageUploaded;
            this.$bvModal.show('image-preview-modal');
        },
        openImageInNewTab(imageSrc) {
            if (!imageSrc) return;
            window.open(imageSrc, '_blank');
        },

    },

    watch: {
        'filter.province': function (newVal) {
            if (newVal && newVal.id) {
                this.getCity(newVal.id);
            } else {
                this.optCity = [];
                this.filter.city = null;
            }
        },
    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listCustomerFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listCustomerFilter"))
        }
        this.init()
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
